export default {
      id: "icon-diamond-usage",
      viewBox: "0 0 122 101",
      url: __webpack_public_path__ + "icons.svg#icon-diamond",
      toString: function () {
        return this.url;
      }
    }